import { render } from "./MarketFilesCount.vue?vue&type=template&id=39ca49ee"
import script from "./MarketFilesCount.vue?vue&type=script&lang=js"
export * from "./MarketFilesCount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__